import { render, staticRenderFns } from "./SearchbarOperationsDetailComponentGlobal.vue?vue&type=template&id=21ce28e1&scoped=true&"
import script from "./SearchbarOperationsDetailComponentGlobal.vue?vue&type=script&lang=js&"
export * from "./SearchbarOperationsDetailComponentGlobal.vue?vue&type=script&lang=js&"
import style0 from "./SearchbarOperationsDetailComponentGlobal.vue?vue&type=style&index=0&id=21ce28e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ce28e1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VSpacer})
